
export const PERIOD_TIME_UNIT = [
    { id: 1, name: "day", key: "DAYS" },
    { id: 2, name: "month", key: "MONTHS" },
    { id: 3, name: "year", key: "YEARS" }
]

/**
 * Enum defined in the backend
 */
export const PERIOD_TIME_UNIT_ENUM = {
    HOURS: {
        id: 0,
        name: "HOURS",
        key: "hour"
    },
    DAYS: {
        id: 1,
        name: "DAYS",
        key: "day"
    },
    WEEKS: {
        id: 2,
        name: "WEEKS",
        key: "week"
    },
    MONTHS: {
        id: 3,
        name: "MONTHS",
        key: "month"
    },
    YEARS: {
        id: 4,
        name: "YEARS",
        key: "year"
    }
}


